export default __webpack_public_path__ + "static/media/SORGO.2484b7ee.png";